import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import { useIntl } from "react-intl";
import { SkuApprovalStatus } from "services/KnowfullyAdminClient";

type ApprovalStatusOption = {
  value: SkuApprovalStatus;
  label: string;
};

type SelectSkuApprovalStatusProps = {
  value?: SkuApprovalStatus;
  onChange: (value?: SkuApprovalStatus) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectSkuApprovalStatus = ({
  value,
  onChange,
  variant,
  disabled,
}: SelectSkuApprovalStatusProps) => {
  const { formatMessage: t } = useIntl();
  const options: ApprovalStatusOption[] = [
    {
      value: SkuApprovalStatus.ActiveApproval,
      label: t({ id: "activeApproval" }),
    },
    {
      value: SkuApprovalStatus.ExpiredApproval,
      label: t({ id: "expiredApproval" }),
    },
    {
      value: SkuApprovalStatus.FutureApproval,
      label: t({ id: "futureApproval" }),
    },
  ];
  const selectedOption =
    options.find((option) => option.value === value) ?? null;

  return (
    <Autocomplete<ApprovalStatusOption>
      value={selectedOption}
      options={options}
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selectedValue) =>
        option.value === selectedValue.value
      }
      onChange={(_event, option) => onChange(option?.value)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={t({ id: "approvalStatusLabel" })}
        />
      )}
    />
  );
};

export default SelectSkuApprovalStatus;
